module.exports = __webpack_public_path__ + "fonts/chevron-left.svg";